import InfoIcon from 'components/ReusableComponents/Icons/Info'
import { getAcceptedFileTypeDetails, maxFileSizeLabel } from 'features/Messaging/fileUploadConfig'
import PropTypes from 'prop-types'
import { useId } from 'react'

import styles from './MediaUploadHints.module.scss'

export const MediaUploadFormatsInfo = ({ acceptedFileTypes, tooltipId: tooltipIdProp }) => {
  const generatedTooltipId = useId().replace(/:/g, '')
  const tooltipId = tooltipIdProp || generatedTooltipId
  const fileTypeDetails = getAcceptedFileTypeDetails(acceptedFileTypes)

  return (
    <div className={styles.formatsInfoWrapper}>
      <button
        type="button"
        className={styles.formatsInfoButton}
        aria-describedby={tooltipId}
        aria-label="View supported file formats"
      >
        <InfoIcon className={styles.formatsInfoIcon} />
      </button>
      <div className={styles.formatsTooltip} id={tooltipId} role="tooltip">
        <p className={styles.formatsTooltipTitle}>Supported formats</p>
        <ul className={styles.formatsTooltipList}>
          {fileTypeDetails.map(({ type, label, extensions }) => (
            <li key={type} className={styles.formatsTooltipItem}>
              <span className={styles.formatsTooltipLabel}>{label}</span>
              <span className={styles.formatsTooltipExtensions}>{extensions}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

MediaUploadFormatsInfo.propTypes = {
  acceptedFileTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  tooltipId: PropTypes.string
}

export const MediaUploadMaxSizeHint = () => {
  return <p className={styles.uploadHint}>Maximum file size: {maxFileSizeLabel}</p>
}

const MediaUploadHints = ({ acceptedFileTypes, tooltipId }) => {
  return (
    <div className={styles.uploadHints}>
      <MediaUploadMaxSizeHint />
      <div className={styles.supportedFormats}>
        <span className={styles.uploadHint}>Supported formats</span>
        <MediaUploadFormatsInfo
          acceptedFileTypes={acceptedFileTypes}
          tooltipId={tooltipId}
        />
      </div>
    </div>
  )
}

MediaUploadHints.propTypes = {
  acceptedFileTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  tooltipId: PropTypes.string
}

export default MediaUploadHints
